import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Key from 'shared/ui/icons/Key';

import styles from './Profile.module.scss';

const PasswordReset: React.FC = () => {
    // eslint-disable-next-line max-len
    const TEXT= t`Вам будет отправлено письмо со ссылкой на форму смены пароля, это необходимо для безопасности вашей учетной записи.`;

    return (
        <div>
            <div className={cn(
                styles.action,
                styles.colorText,
            )}>
                <Key />
                {t`Изменить пароль`}
            </div>
            <p className={styles.text}>
                {TEXT}
            </p>
        </div>
    );
};

export default PasswordReset;